import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ColorsService } from "./colors/colors.service";
import { RouterModule } from "@angular/router";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { AlertModule } from "ngx-bootstrap/alert";
import { SortService } from "./tables/sort.service";
import { SortableColumnComponent } from "./tables/sortable-column.component";
import { SortableTableDirective } from "./tables/sortable-table.directive";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { BsDatepickerModule, DatepickerModule } from "ngx-bootstrap/datepicker";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { ViewTransactionComponent } from "./components/view-transaction/view-transaction.component";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // AccordionModule.forRoot(),
    AlertModule.forRoot(),
    // ButtonsModule.forRoot(),
    // CarouselModule.forRoot(),
    // CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    // BsDropdownModule.forRoot(),
    // ModalModule.forRoot(),
    PaginationModule.forRoot(),
    // ProgressbarModule.forRoot(),
    // RatingModule.forRoot(),
    TabsModule.forRoot(),
    // TimepickerModule.forRoot(),
    // TooltipModule.forRoot(),
    // PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgxIntlTelInputModule,
    CarouselModule.forRoot(),
  ],
  providers: [ColorsService, SortService],
  declarations: [
    SortableColumnComponent,
    SortableTableDirective,
    PageHeaderComponent,
    ViewTransactionComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // AccordionModule,
    AlertModule,
    // ButtonsModule,
    // CarouselModule,
    // CollapseModule,
    DatepickerModule,
    BsDatepickerModule,
    // BsDropdownModule,
    // ModalModule,
    PaginationModule,
    // ProgressbarModule,
    TabsModule,
    // TimepickerModule,
    // TooltipModule,
    // PopoverModule,
    TypeaheadModule,
    // SparklineDirective,
    // ScrollableDirective,
    SortableColumnComponent,
    SortableTableDirective,
    NgxIntlTelInputModule,
    CarouselModule,
    PageHeaderComponent,
    ViewTransactionComponent,
    // FlotDirective
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
